import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const KbArticlesPage = lazy(() => import('./pages/KbArticlesPage'));
const CustomerPortalPage = lazy(() => import('./pages/CustomerPortalPage'));
const KbSearchPage = lazy(() => import('./pages/KbSearchPage'));

export const KnowledgeRoutes: RouteObject = {
  path: 'knowledge',
  element: <ModuleGuard moduleId="support.knowledge" />,
  handle: { crumb: 'Self-Service & KB' },
  children: [
    { index: true, element: <Navigate to="kb-articles" replace /> },
    { path: 'kb-articles', element: <KbArticlesPage />, handle: { crumb: 'KB Articles' } },
    { path: 'customer-portal', element: <CustomerPortalPage />, handle: { crumb: 'Customer Portal' } },
    { path: 'kb-search', element: <KbSearchPage />, handle: { crumb: 'KB Search' } },
  ],
};
